module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/yes.0e170df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/yes.jpg
// module id = AtSj
// module chunks = 0